<template>
  <div class="error-page">
    <div class="error-content">
      <div class="error-icon">
        <svg width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>

      <h1 class="error-title">{{ error.statusCode === 404 ? '페이지를 찾을 수 없습니다' : '오류가 발생했습니다' }}</h1>

      <p class="error-message">
        {{
          error.statusCode === 404 ? '요청하신 페이지가 존재하지 않거나 이동되었습니다.' : error.statusMessage || '예상치 못한 오류가 발생했습니다.'
        }}
      </p>

      <div class="error-actions">
        <UiButton variant="primary" @click="handleRedirect" class="redirect-btn">메인 페이지로 이동</UiButton>

        <UiButton variant="secondary" @click="$router.go(-1)" class="back-btn">이전 페이지로</UiButton>
      </div>
    </div>
  </div>
</template>

<script setup>
// 에러 정보 받기
const props = defineProps({
  error: {
    type: Object,
    required: true,
  },
});

const router = useRouter();
const { navigateToHome } = useHomeNavigation();

// 에러 로그 출력 - error.vue 렌더링 시 자동 실행
const logErrorTrace = () => {
  console.group('%c🚨 ERROR.VUE 렌더링됨', 'background: #ff0000; color: white; padding: 4px 8px; font-weight: bold;');

  console.log('%c에러 정보:', 'color: #e74c3c; font-weight: bold;');
  console.log('├─ Status Code:', props.error.statusCode);
  console.log('├─ Status Message:', props.error.statusMessage);
  console.log('├─ Message:', props.error.message);

  if (props.error.stack) {
    console.log('%c스택 트레이스:', 'color: #e74c3c; font-weight: bold;');
    console.log(props.error.stack);
  }

  if (props.error.data) {
    console.log('%c추가 데이터:', 'color: #e74c3c; font-weight: bold;');
    console.log(props.error.data);
  }

  console.log('%c현재 라우트:', 'color: #3498db; font-weight: bold;');
  console.log('├─ Path:', router.currentRoute.value.path);
  console.log('├─ Name:', router.currentRoute.value.name);
  console.log('├─ Params:', router.currentRoute.value.params);
  console.log('├─ Query:', router.currentRoute.value.query);

  console.log('%c전체 에러 객체:', 'color: #95a5a6; font-weight: bold;');
  console.log(props.error);

  console.groupEnd();
};

// 컴포넌트 마운트 시 에러 로그 출력
onMounted(() => {
  logErrorTrace();
});

// 메인 페이지로 이동 (로고 클릭과 동일: viewType A/T 분기)
const handleRedirect = async () => {
  clearError();
  await navigateToHome();
};

// 자동 리다이렉트 제거 - 사용자가 버튼을 클릭해서만 이동하도록 함

// SEO를 위한 메타 설정
useHead({
  title: `${props.error.statusCode} - ${props.error.statusCode === 404 ? '페이지를 찾을 수 없습니다' : '오류가 발생했습니다'}`,
});
</script>

<style lang="scss" scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
}

.error-content {
  text-align: center;
  max-width: 500px;
  width: 100%;
  background: white;
  padding: 60px 40px;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
}

.error-icon {
  color: #e74c3c;
  margin-bottom: 30px;

  svg {
    width: 80px;
    height: 80px;
  }
}

.error-title {
  font-size: 32px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 16px;
  line-height: 1.2;
}

.error-message {
  font-size: 16px;
  color: #7f8c8d;
  margin-bottom: 40px;
  line-height: 1.6;
}

.error-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.redirect-btn,
.back-btn {
  min-width: 140px;
}

@media (max-width: 768px) {
  .error-content {
    padding: 40px 20px;
  }

  .error-title {
    font-size: 24px;
  }

  .error-actions {
    flex-direction: column;
    align-items: center;
  }

  .redirect-btn,
  .back-btn {
    width: 100%;
    max-width: 200px;
  }
}
</style>
